import scss from "./EmptyState.module.scss";

const EmptyState = ({ icon, kind = "notification", title, description, children }) => (
    <div className={scss.panel} role="status">
        <span className={scss.icon} aria-hidden="true">{icon ?? (
            <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                {kind === "wishlist" ? (
                    <path d="M24 38S9 29 9 18.5a8.5 8.5 0 0 1 15-5.4 8.5 8.5 0 0 1 15 5.4C39 29 24 38 24 38Z" />
                ) : kind === "orders" ? (
                    <><rect x="12" y="8" width="24" height="32" rx="3" /><path d="M18 17h12M18 24h12M18 31h7" /></>
                ) : (
                    <><path d="M34 17a10 10 0 0 0-20 0c0 12-5 12-5 17h30c0-5-5-5-5-17ZM20 39h8" /><path d="M24 8v-2" /></>
                )}
            </svg>
        )}</span>
        <h2>{title}</h2>
        <p>{description}</p>
        {children}
    </div>
);

export default EmptyState;
